import React from "react";

export function Help() {
  window.scrollTo(0, 0);
  const constStyle = {
    width: "100%",
    heigth: "50vh",
    marginTop: "50vh",
    textAlign: "center",
  };
  const constStyl = {
    fontFamily: "Segoe UI",
    fontSize: "large",
    fontWeight: "400",
    color: "green",
    letterSpacing: "normal",
  };

  return (
    <>
      <div style={constStyle}>
        <h5 style={constStyl} lang="es">
          Agregando contenido y funciones
        </h5>
        <br />
        <h5 style={constStyl} lang="es">
          <code>|[</code> Ajustando detalles <code>]|</code>
        </h5>
      </div>
    </>
  );
}
